function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Path_1738",
  x: 0,
  y: 0,
  width: 50,
  height: 58,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 0, 0)",
  filter: "url(#Path_1738)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1738-2",
  "data-name": "Path 1738",
  d: "M422.109,497.864l-16,16.438v23.562h32V514.3ZM432.96,528.2a.974.974,0,0,1-1.41,0,1.059,1.059,0,0,1,0-1.46l.492-.51H412.157l.492.51a1.057,1.057,0,0,1,0,1.46.974.974,0,0,1-1.41,0l-2.8-2.9,2.8-2.9a.973.973,0,0,1,1.41,0,1.057,1.057,0,0,1,0,1.46l-.3.313h19.505l-.3-.313a1.059,1.059,0,0,1,0-1.46.973.973,0,0,1,1.41,0l2.8,2.9Z",
  transform: "translate(-397.11 -491.86)",
  fill: "#f2f2f2"
}));

function SvgRoomDimensionsNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 58,
    viewBox: "0 0 50 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomDimensionsNew);
export default __webpack_public_path__ + "static/media/room-dimensions-new.30c6f587.svg";
export { ForwardRef as ReactComponent };